define("shared/utils/formatters/tweet-from-dynamo", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Formats a raw dynamo tweet response
   *
   * @method createTweetFromDynamo
   * @param {RawDynamoTweet} obj Raw dynamo tweet object
   *
   * @returns {FormattedDynamoTweet} Returns a formatted tweet
   */
  function createTweetFromDynamo(rawTweet) {
    const caption = replaceLinksWithOriginal(removeMediaUrls(rawTweet.text, rawTweet.tw_media_urls), rawTweet.urls);
    return {
      id: rawTweet.id,
      uid: rawTweet.uid,
      standardResUrl: rawTweet.media_url,
      thumbUrl: rawTweet.media_url,
      isVideo: rawTweet.media_type == 'video' || rawTweet.media_type == 'animated_gif',
      isTwitterCarousel: rawTweet.is_multi_photo,
      isDeleted: rawTweet.is_deleted,
      createdTime: rawTweet.created_time,
      caption: caption ? caption.trim() : '',
      followersCount: rawTweet.followers_on_post,
      favoriteCount: rawTweet.favorite_count,
      retweetCount: rawTweet.retweet_count,
      shortcodes: rawTweet.shortcodes,
      clicks: rawTweet.clicks,
      type: 'tweet'
    };
  }
  function removeMediaUrls(caption, mediaUrls) {
    let sanitizedCaption = caption;
    if (mediaUrls && caption) {
      mediaUrls.forEach(url => {
        sanitizedCaption = caption.replace(url, '');
      });
    }
    return sanitizedCaption;
  }
  function replaceLinksWithOriginal(caption, urlObjects) {
    let sanitizedCaption = caption;
    if (urlObjects && caption) {
      urlObjects.forEach(urlObj => {
        sanitizedCaption = caption.replace(urlObj.url, urlObj.expanded_url);
      });
    }
    return sanitizedCaption;
  }
  var _default = _exports.default = createTweetFromDynamo;
});